import styled from "styled-components";
import { CSSVars } from "../../styles/styles.config";

export const StyledSection = styled.section`
  padding: 0 20px 50px;
  max-width: 920px;
  margin: 0 auto;
  text-align: center;
  font-family: ${CSSVars.primaryFont};

  .own {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: ${CSSVars.blue500};
    font-size: ${CSSVars.fontSizeMD};
    font-weight: 600;
    text-decoration: none;

    &:hover {
      color: ${CSSVars.blue300};
    }

    .icon {
      padding-top: 2px;
    }
  }

  .label {
    margin: 24px 0 12px;
    color: ${CSSVars.gray600};
    font-size: ${CSSVars.fontSizeSM};
    font-weight: 300;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }

  li a {
    display: inline-block;
    padding: 6px 14px;
    border: 1px solid ${CSSVars.gray200};
    border-radius: 999px;
    color: ${CSSVars.gray800};
    font-size: ${CSSVars.fontSizeSM};
    text-decoration: none;

    &:hover {
      border-color: ${CSSVars.blue500};
      color: ${CSSVars.blue500};
    }
  }

  &.after-tiles {
    margin-top: -50px;
  }

  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 0 40px 100px;

    &.after-tiles {
      margin-top: -100px;
    }
  }
`;
